export const ServicesData = [
  {
    id: 1,
    icon: '../../images/icon-1.svg',
    alt: 'support',
    heading: 'This is the first one',
    subheading: 'This is the subheading',
    body: 'This is the body',
  },
  {
    id: 2,
    icon: '/images/icon-2.svg',
    alt: 'joint investment',
    heading: 'This is the 2nd one',
    subheading: 'This is the subheading',
    body: 'This is the body',
  },
  {
    id: 3,
    icon: '/images/icon-3.svg',
    alt: 'real state',
    heading: 'This is the third one',
    subheading: 'This is the subheading',
    body: 'This is the body',
  },
];
